import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/ESPMechanicalSparesHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-33.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .espm { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .espm-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .espm-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .espm-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .espm-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .espm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .espm-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .espm-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .espm-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .espm-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .espm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .espm-bc-item:hover { color: #EB2019; }
  .espm-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .espm-bc-sep img { width: 24px; height: 24px; display: block; }
  .espm-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .espm-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .espm-main-section { padding: 80px 0 120px 0; }
  .espm-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .espm-article { flex: 1; min-width: 0; }

  .espm-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .espm-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .espm-meta-item:last-child { border-right: none; padding-right: 0; }
  .espm-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .espm-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .espm-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .espm-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .espm-article-body p { margin-bottom: 20px; }
  .espm-article-body p:last-child { margin-bottom: 0; }

  .espm-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .espm-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: espm-counter;
  }
  .espm-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: espm-counter;
  }
  .espm-article-body ol li::before {
    content: counter(espm-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .espm-article-body ol li > span { flex: 1; }

  .espm-article-body strong { font-weight: 600; color: #202020; }

  .espm-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .espm-red-link:hover { opacity: 0.8; }

  .espm-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .espm-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .espm-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .espm-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .espm-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .espm-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .espm-nav-btn:hover { color: #EB2019; }
  .espm-nav-btn img { width: 40px; height: 40px; display: block; }

  .espm-share-icons { display: flex; align-items: center; gap: 20px; }
  .espm-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .espm-share-icon:hover { opacity: 0.85; }
  .espm-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .espm-sidebar { flex: 0 0 475px; }
  .espm-sidebar-block { margin-bottom: 60px; }
  .espm-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .espm-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .espm-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .espm-recent-item:hover .espm-recent-title { color: #EB2019; }
  .espm-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .espm-recent-body { flex: 1; min-width: 0; }
  .espm-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .espm-social-icons { display: flex; align-items: center; gap: 30px; }
  .espm-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .espm-social-icon:hover { opacity: 0.8; }
  .espm-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .espm-hero             { height: 350px; }
    .espm-hero-content     { padding: 0 32px; }
    .espm-hero-title       { font-size: 30px; }
    .espm-hero-divider     { width: 100%; max-width: 479px; }
    .espm-breadcrumb       { padding: 24px 0 0 0; }
    .espm-breadcrumb-inner { padding: 0 32px; }
    .espm-inner            { padding: 0 32px; }
    .espm-main-section     { padding: 48px 0 60px 0; }
    .espm-main-row         { flex-direction: column; gap: 48px; }
    .espm-sidebar          { flex: none; width: 100%; }
    .espm-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .espm-hero             { height: 360px; }
    .espm-hero-content     { padding: 0 16px; }
    .espm-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .espm-hero-divider     { width: 100%; }
    .espm-hero-subtitle    { font-size: 14px; }
    .espm-breadcrumb       { padding: 30px 0 0 0; }
    .espm-breadcrumb-inner { padding: 0 16px; }
    .espm-bc-item          { font-size: 14px; gap: 14px; }
    .espm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .espm-bc-sep img       { width: 22px; height: 22px; }
    .espm-inner            { padding: 0 16px; }
    .espm-main-section     { padding: 30px 0 60px 0; }
    .espm-main-row         { flex-direction: column; gap: 60px; }
    .espm-sidebar          { flex: none; width: 100%; }
    .espm-article-title    { font-size: 20px; margin-bottom: 15px; }
    .espm-article-body     { font-size: 14px; }
    .espm-article-body p   { margin-bottom: 15px; }
    .espm-article-body ol  { margin: 0 0 20px 0; gap: 15px; }
    .espm-article-body ol li { font-size: 14px; }
    .espm-article-body strong { font-size: 16px; }
    .espm-meta-item        { font-size: 14px; }
    .espm-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .espm-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .espm-hashtags         { margin-top: 30px; font-size: 14px; }
    .espm-nav-btn img      { width: 24px; height: 24px; }
    .espm-nav-btn          { font-size: 14px; }
    .espm-share-icon img   { width: 34px; height: 34px; }
    .espm-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function ESPMechanicalSpares() {
  return (
    <div className="espm">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="espm-hero">
        <img className="espm-hero-bg" src={HeroBgImg} alt="5 Signs You Need to Replace Your ESP Mechanical Spares Hero" />
        <div className="espm-hero-overlay" />
        <div className="espm-hero-content">
          <h1 className="espm-hero-title">
            5 Signs You Need to Replace Your ESP Mechanical Spares
          </h1>
          <hr className="espm-hero-divider" />
          <p className="espm-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="espm-breadcrumb" aria-label="Breadcrumb">
        <div className="espm-breadcrumb-inner">
          <a href="/" className="espm-bc-item">Home</a>
          <span className="espm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="espm-bc-item">News &amp; Updates</a>
          <span className="espm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="espm-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="espm-main-section">
        <div className="espm-inner">
          <div className="espm-main-row">

            {/* ── ARTICLE ── */}
            <article className="espm-article">

              {/* Meta bar */}
              <div className="espm-meta-bar">
                <span className="espm-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="espm-meta-item"><img src={CalendarIcon} alt="date" /> November 16, 2024</span>
                <span className="espm-meta-item"><img src={ClockIconImg} alt="time" /> 5:29 am</span>
                <span className="espm-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="espm-article-title">
                5 Signs You Need to Replace Your ESP Mechanical Spares
              </h1>

              {/* Body */}
              <div className="espm-article-body">

                <p>Electrostatic Precipitators (ESPs) are essential for controlling particulate emissions in industrial operations, but like any mechanical system, they require regular upkeep to maintain their efficiency. Over time, <a href="/products/" className="espm-red-link-plain">ESP mechanical and spares</a> may wear out, impacting the system's performance and your facility's compliance with environmental standards.</p>

                {/* Article image */}
                <img className="espm-article-img" src={ArticleImg} alt="ESP Mechanical Spares" />

                <p>Here are five key signs that indicate it's time to replace your ESP mechanical spares.</p>

                <ol>
                  <li><span><strong>Decreased Dust Collection Efficiency</strong><br />
                  A noticeable drop in dust collection efficiency is one of the first signs of worn-out ESP mechanical spares. If your ESP struggles to capture airborne particles, dust, and fly ash, it's often due to worn or failing components. A drop in efficiency can be caused by mechanical issues with parts such as the rapping mechanism, discharge electrodes, or collection plates, which all play critical roles in removing particles from exhaust gases. Regular inspection and timely replacement of these mechanical spares will help keep your ESP operating at peak performance.</span></li>

                  <li><span><strong>Frequent Downtime and Maintenance</strong><br />
                  If your ESP requires constant maintenance or frequently breaks down, it strongly indicates that your mechanical spares are wearing out. Frequent repairs can disrupt your production schedule and increase operational costs. Common culprits include rapping systems, which may fail to clear particle buildup, and the discharge electrodes, which can become less effective over time. Replacing worn-out <a href="/products/" className="espm-red-link-plain">ESP spares and services</a> with high-quality parts can drastically reduce downtime and maintenance requirements, improving system reliability.</span></li>

                  <li><span><strong>Increased Energy Consumption</strong><br />
                  A well-functioning ESP should operate efficiently without using excessive energy. However, as mechanical components age, the ESP may consume more power to achieve the same level of performance. For example, worn discharge electrodes or inefficient collection plates can cause the ESP to draw more power to maintain its electric field. Regularly monitoring the system's energy consumption can help detect these inefficiencies. Inspecting and replacing the relevant ESP mechanical spares is a good idea if you notice a significant increase.</span></li>

                  <li><span><strong>Visible Wear and Tear on Components</strong><br />
                  Physical wear and tear on ESP components indicates that replacements are needed. Parts such as discharge electrodes, collection plates, and rapping hammers are subject to continuous mechanical stress, which can lead to corrosion, warping, or fractures over time. Regular visual inspections are essential for identifying worn parts before they cause significant damage to the system. Replacing these spares prevents performance issues and extends the lifespan of your ESP.</span></li>

                  <li><span><strong>Reduced Compliance with Emission Standards</strong><br />
                  One of an ESP's most essential functions is helping facilities meet environmental regulations by controlling emissions. If your ESP is no longer meeting emission standards, it may be due to worn mechanical spares. Components like collection plates and discharge electrodes ensure effective particle capture. If they do not function optimally, your ESP may need help keeping emissions within regulatory limits. Replacing outdated or damaged parts is essential to restore compliance and protect your facility from potential fines or shutdowns.</span></li>
                </ol>

                <span className="espm-h2">Invest in Quality ESP Mechanical Spares</span>

                <p>Regularly monitoring your ESP for these signs can help prevent costly issues and ensure long-term performance. At Ador, we specialize in providing high-quality <strong>ESP mechanical and spares</strong> tailored to meet the demands of various industrial applications. Our durable components, from discharge electrodes to rapping mechanisms, ensure reliable operation and enhanced dust collection efficiency.</p>

                <p>Ensure your ESP system stays in top condition. Contact <a href="/contact-us" className="espm-red-link-plain">Ador</a> today to explore our ESP mechanical and spare services range for optimal performance and compliance.</p>

                <p className="espm-hashtags"><strong>#ESPMechanicalSpares #ElectrostaticPrecipitator #IndustrialDustControl #AdorGroup #EmissionCompliance #ESPPerformance</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="espm-bottom-row">
                <div className="espm-bottom-nav">
                  <a href="/news/environmental-benefits-emission-control" className="espm-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/upgrading-transformer-rectifier-systems" className="espm-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="espm-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/5-signs-you-need-to-replace-your-esp-mechanical-spares/" className="espm-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F&mode=login" className="espm-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F%26title%3D5%2520Signs%2520to%2520Replace%2520Your%2520ESP%2520Mechanical%2520Spares%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F" className="espm-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="espm-sidebar">

              {/* Recent Posts */}
              <div className="espm-sidebar-block">
                <p className="espm-sidebar-title">Recent Posts</p>
                <div className="espm-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="espm-recent-item">
                      <img src={post.img} alt={post.title} className="espm-recent-img" />
                      <div className="espm-recent-body">
                        <span className="espm-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="espm-sidebar-block">
                <p className="espm-sidebar-title">Social Media</p>
                <div className="espm-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="espm-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="espm-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}